import React from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { useSidebar } from '../contexts/SidebarContext';
export function Layout() {
  const {
    mode
  } = useSidebar();
  const marginLeft = mode === 'expanded' ? 'md:ml-64' : 'md:ml-20';
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-62">
      <Sidebar data-id="element-63" />
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${marginLeft}`} data-id="element-64">
        <Topbar data-id="element-65" />
        <main className="flex-1 overflow-y-auto p-4 sm:p-6" data-id="element-66">
          <Outlet data-id="element-67" />
        </main>
      </div>
    </div>;
}